import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router'
import { twMerge } from 'tailwind-merge'

import { isActive } from './helpers'
import { useTableOfContents } from '../hooks/useTableOfContents'
import { useEntitlements } from '~/portal/hooks/useEntitlements'

const LinkItem = ({ children, to, isActive }) => (
  <Link
    to={to}
    className={twMerge(
      'sp-doc-toc-link py-1 px-2 block hover:text-(--sp-color-link) border-l-2 border-transparent hover:border-(--sp-color-link)',
      isActive && 'sp-doc-toc-link--active text-(--sp-color-link) font-semibold border-(--sp-color-link)',
    )}
  >
    {children}
  </Link>
)

export const TableOfContents = ({ tableOfContents }: { tableOfContents: any[] }) => {
  const currentSection = useTableOfContents(tableOfContents)

  const { sbFooterRemoved } = useEntitlements()

  const { t } = useTranslation()

  const location = useLocation()

  if (!tableOfContents.length) {
    return null
  }

  return (
    <div className="sp-doc-toc">
      <div
        className={clsx(
          'sm:hidden xl:sticky xl:top-0 xl:right-0 xl:-mr-6 xl:block xl:flex-none xl:self-start xl:overflow-y-auto xl:pt-13 xl:mb-12 2xl:ml-4 xl:px-4 w-[256px]',
          'dark:text-neutral-20',
          sbFooterRemoved ? 'xl:max-h-[calc(100vh-60px)]' : 'xl:max-h-[calc(100vh-100px)]'
        )}
        data-testid="page-navigation"
      >
        <nav aria-labelledby="on-this-page-title" className="sp-doc-toc-nav w-full">
          <>
            <h2
              id="on-this-page-title"
              className="px-2 py-1 font-medium border-l-2 border-transparent text-body1 font-display"
            >
              {t('consumer.product.tableOfContent.header')}
            </h2>
            <ol role="list" className="w-full mt-2 space-y-3 text-body2">
              {tableOfContents.map(section => (
                <li key={section.id}>
                  <h3>
                    <LinkItem 
                      to={`${location.search}#${encodeURIComponent(section.id)}`}
                      isActive={isActive(section, currentSection)}
                    >
                      {section.title}
                    </LinkItem>
                  </h3>
                  {section.children.length > 0 && (
                    <ol
                      role="list"
                      className="pl-5 mt-2 space-y-3"
                    >
                      {section.children.map(subSection => (
                        <li key={subSection.id}>
                          <LinkItem to={`${location.search}#${encodeURIComponent(subSection.id)}`}
                            isActive={isActive(subSection, currentSection)}>
                            {subSection.title}
                          </LinkItem>

                        </li>
                      ))}
                    </ol>
                  )}
                </li>
              ))}
            </ol>
          </>
        </nav>
      </div>
    </div>
  ) 
}